import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { AddProductTypeProp } from "../types/making.type";
import { ProductTypeFormModel } from "../model/making.type.model";

const AddProductType: React.FC<AddProductTypeProp> = ({
    isAddProductTypeOpen,
    onClose,
    reloadDataSource,
    selectedId = null
}) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm<ProductTypeFormModel>();

    const onSubmit = (data: ProductTypeFormModel) => {
        const payload = {...data}
        if(selectedId !=null && selectedId > 0 ) {
            payload.id=selectedId
        }
        const formatedData = ProductTypeFormModel.setProductTypeFromData(payload);
        console.log("Vendor Submitted:", formatedData);
        reloadDataSource();
        // reset();
        // onClose();
    };

    return (
        <Modal
            show={isAddProductTypeOpen}
            onHide={onClose}
            backdrop="static"
            dialogClassName="modal-dialog-centered"
        >
            <Modal.Header closeButton>
                <Modal.Title>{!selectedId ? 'Add Making Type' : 'Update Making Type'}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">
                                Making Type <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter making type"
                                maxLength={20}
                                className={`form-control ${errors.productType ? "is-invalid" : ""
                                    }`}
                                {...register("productType", {
                                    required: "Making type is required",
                                    pattern: {
                                        value: /^(?!\s)([A-Za-z]+(\s{1,}[A-Za-z]+)*)$/,
                                        message:
                                            "Only letters and spaces are allowed. No leading or trailing spaces.",
                                    },
                                })}
                            />
                            {errors.productType && (
                                <div className="text-danger small mt-1">
                                    {errors.productType.message}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex justify-content-end  align-items-end mt-4">
                        <button
                            type="button"
                            className="btn add-btn me-1"
                            onClick={() => {
                                onClose()
                                reset();
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn submit-btn"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Submitting..." : "Add"}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default AddProductType;
